import React, { useState } from "react";
import * as styles from "./base.scss";
import connect from "Shared/connect";
import Modal from "Shared/Modal";
import EmvProductDetail from "../../../Checkout/FullCart/ProductList/EmvProductDetail";
import { getProductDetails } from "../../../Checkout/action-creators";
import Spinner from "Shared/Spinner";
import classnames from "classnames";
import { addEcommerceEventToDataLayer, getGa4ItemListReferrel, getGa4ItemListReferrelContext, setGa4ItemListReferrelContextFromEvent } from "./../../../TrackingInformation";
const ProductPreview = ({ product, getProductDetails, selectedVariant, className, children, selectItemEventList, selectItemEvent, }) => {
    const [isLoading, setLoading] = useState(false);
    const [productDetailModal, setProductDetailModal] = useState(false);
    const [productDetails, setProductDetails] = useState();
    const sendGa4SelectItemEvent = () => {
        if (!!selectItemEvent) {
            setGa4ItemListReferrelContextFromEvent(selectItemEvent);
            addEcommerceEventToDataLayer(selectItemEvent);
        }
        else if (!!selectedVariant &&
            !!selectItemEventList &&
            selectedVariant.code in selectItemEventList) {
            const currentPageSelectItemEvent = selectItemEventList[selectedVariant.code];
            setGa4ItemListReferrelContextFromEvent(currentPageSelectItemEvent);
            addEcommerceEventToDataLayer(currentPageSelectItemEvent);
        }
    };
    const sendGa4ViewItemEvent = (productViewModel) => {
        if (!!productViewModel &&
            !!productViewModel.trackingData &&
            !!productViewModel.trackingData.ga4EventObjects &&
            "view_item" in productViewModel.trackingData.ga4EventObjects) {
            const events = productViewModel.trackingData.ga4EventObjects[String("view_item")];
            const event = events[selectedVariant.code];
            !!event && addEcommerceEventToDataLayer(event);
        }
    };
    const getProductUrlWithGa4Referral = () => {
        const url = product.url.toString();
        const ga4ItemListReferrel = getGa4ItemListReferrelContext() || getGa4ItemListReferrel();
        if (!ga4ItemListReferrel)
            return url;
        const separator = url.includes('?') ? '&' : '?';
        return `${url}${separator}ga4ItemListReferrel=${encodeURIComponent(ga4ItemListReferrel)}`;
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("a", { className: classnames(styles.preview, className), onClick: () => {
                setLoading(true);
                sendGa4SelectItemEvent();
                getProductDetails(getProductUrlWithGa4Referral())
                    .then((r) => {
                    setProductDetails(r);
                    sendGa4ViewItemEvent(r);
                })
                    .then(() => setProductDetailModal(true))
                    .then(() => setLoading(false));
            } },
            children,
            !!isLoading && React.createElement(Spinner, { className: styles.spinner })),
        React.createElement(Modal, { isOpen: productDetailModal, onClose: () => setProductDetailModal(false) },
            React.createElement(EmvProductDetail, { productViewModel: productDetails, selectedVariant: selectedVariant }))));
};
export default connect((state) => ({
    selectItemEventList: state.currentPage &&
        state.currentPage.trackingData &&
        state.currentPage.trackingData.ga4EventObjects &&
        state.currentPage.trackingData.ga4EventObjects["select_item"],
}), (dispatch) => ({
    getProductDetails(url) {
        return dispatch(getProductDetails(url));
    },
}))(ProductPreview);
